import { useTranslation } from 'react-i18next'

import { TextareaOutlineField } from '../../../Textarea'
import {
  GRETA_FEEDBACK_COMMENT_MAX_LENGTH,
  GRETA_FEEDBACK_COMMENT_MAX_ROWS,
  GRETA_FEEDBACK_COMMENT_MIN_ROWS,
  QA_NAME_GRETA_AI_CHAT_FEEDBACK_COMMENT,
} from '../GretaAIChatFeedbackForm.constants'

import * as styles from './GretaAIChatFeedbackComment.module.css'

function GretaAIChatFeedbackComment({ comment, isDown, onChange }) {
  const { t } = useTranslation()

  return (
    <div className={styles.commentField}>
      <TextareaOutlineField
        autoResizeHeight
        withoutManualResize
        className={styles.comment}
        label={t('Greta.FeedbackDetailsLabelKey')}
        maxLength={GRETA_FEEDBACK_COMMENT_MAX_LENGTH}
        maxRows={GRETA_FEEDBACK_COMMENT_MAX_ROWS}
        minRows={GRETA_FEEDBACK_COMMENT_MIN_ROWS}
        placeholder={
          isDown
            ? t('Greta.FeedbackPlaceholderDownKey')
            : t('Greta.FeedbackPlaceholderUpKey')
        }
        qaName={QA_NAME_GRETA_AI_CHAT_FEEDBACK_COMMENT}
        value={comment}
        onChange={onChange}
      />
    </div>
  )
}

export default GretaAIChatFeedbackComment
